export const SET_ORGANIZER = "SET_ORGANIZER";

export const setOrganizer = (organizer) => {
  return {
    type: SET_ORGANIZER,
    payload: organizer,
  };
};
